export default "__VITE_ASSET__Di9p3z5T__"